export default __webpack_public_path__ + "static/media/gallery-wip-weathering_00.2dc02f32.jpg";